import { Component } from '@angular/core';
import { BasicList } from '../../../../classes';
import { LoopBackConfig, LoopBackAuth } from '../../../../../assets/js/lb-sdk';
import { BsModalService } from 'ngx-bootstrap';
import { STORAGE_LOCATIONS, ORDER_STATUS, PAYMENT_TYPE } from '../../../../enums';
import { OrderApi } from '../../../../../assets/js/lb-sdk/services/custom/Order';

@Component({
  selector: 'app-over-payment',
  templateUrl: './over-payment.component.html',
  styleUrls: ['./over-payment.component.css']
})
export class OverPaymentComponent extends BasicList {
  searchSettings = {
    searchFields: [],
    searchableFields: [
      { name: 'reference', placeholder: 'Reference Number', exact: true }
    ],
    filters: {}
  };
  host:string = LoopBackConfig.getPath();
  container:string = STORAGE_LOCATIONS.PRODUCT_IMAGES;
  ORDER_STATUS: typeof ORDER_STATUS = ORDER_STATUS;
  PAYMENT_TYPE: typeof PAYMENT_TYPE = PAYMENT_TYPE;

  constructor(
    private ordersApi: OrderApi,
    private modalService: BsModalService,
    private loopBackAuth: LoopBackAuth
  ) {
    super();
    this.searchSettings.searchFields.push(this.searchSettings.searchableFields[0]);
    this.params = {
      where: {},
      order: 'dateCreated DESC'
    };
    this.settings = {
      createComponent: undefined,
      api: {
        paginate: this.ordersApi.overPayments.bind(this.ordersApi),
        deleteById: this.ordersApi.deleteById.bind(this.ordersApi)
      },
      ModalService: this.modalService
    };
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }

  hasPaymentType(type) {
    if (!this.getUser()) {
      return false;
    }
    return (this.getUser().roles || [])
      .filter(role => {
        return role.paymentType === type;
      }).length > 0;
  }
}
